import { render } from "./AssignedResourceDetailToTask.vue?vue&type=template&id=030ce9e9&ts=true"
import script from "./AssignedResourceDetailToTask.vue?vue&type=script&lang=ts"
export * from "./AssignedResourceDetailToTask.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__